// For iOS 8
const initDateNow = () => new Date().getTime()

const initPerformance = () => {
  window.performance = {}
  Date.now = Date.now || initDateNow

  if (!window.performance.now) {
    let nowOffset = Date.now()

    if (window.performance.timing && window.performance.timing.navigationStart) {
      nowOffset = window.performance.timing.navigationStart
    }
    window.performance.now = () => Date.now() - nowOffset
  }
}

export default initPerformance
